module.exports = __webpack_public_path__ + "static/media/16plgconcepillo.b0ef62c7.jpg";